import { COLOR_THEME } from '../../style/colorTheme';

interface IProps {
  verticalMargin?: string;
}

export default function DivideLine({ verticalMargin }: IProps) {
  const lineStyle = {
    position: 'relative' as const,
    width: '100%',
    height: ' 1px',
    boxSizing: 'border-box' as const,
    background: 'rgba(255, 255, 255, 0.2)',
    margin: `${verticalMargin || '24px'} 0`,
  };
  return <div style={lineStyle} />;
}
